'use client';
import { List, ListItem } from '@mui/material';
import { Container } from '@mui/system';
import { IconCircleCheckFilled } from '@tabler/icons-react';
import { useMemo } from 'react';

import GlobalBlockRenderer from '@/components/ContentBlocks/GlobalBlockRenderer/GlobalBlockRenderer';
import { CustomBackground } from '@/components/CustomBackground/CustomBackground';
import { StrapiBackgroundOptions, StrapiDisplayOptions } from '@/lib/DisplayOptionsHelper';
import {
  ComponentBlocksHeroSimple,
  Enum_Componentshareddisplayoptions_Contentswidth,
} from '@/types';

interface SimpleHeroProps {
  content: ComponentBlocksHeroSimple;
}

export function SimpleHero({ content }: SimpleHeroProps) {
  const bullets = useMemo(() => {
    return content?.SimpleHeroBullets ? content?.SimpleHeroBullets?.split('\n') : [];
  }, [content?.SimpleHeroBullets]);

  return (
    <CustomBackground
      backgroundOptions={(content?.SimpleHeroBackground ?? undefined) as StrapiBackgroundOptions}
      displayOptions={
        {
          ...content?.SimpleHeroDisplayOptions,
          ContentsWidth:
            content?.SimpleHeroDisplayOptions?.ContentsWidth ??
            Enum_Componentshareddisplayoptions_Contentswidth.Wide,

          PaddingTop: content?.SimpleHeroDisplayOptions?.PaddingTop ?? 'xs',
          PaddingBottom: content?.SimpleHeroDisplayOptions?.PaddingBottom ?? 'xs',
          PaddingInline: content?.SimpleHeroDisplayOptions?.PaddingInline ?? 'xs',
        } as StrapiDisplayOptions
      }
      boxProps={{
        // @ts-expect-error - this does work, but types are not correct
        'data-component': 'SimpleHero',
      }}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          pt: 2,
          pb: 3,
          'h1,h2,h3,h4,h6': {
            mb: 1,
          },
          'p.MuiTypography-root': {
            m: 0,
            mb: 1,
          },
        }}
      >
        <GlobalBlockRenderer content={content.SimpleHeroText} />
        {bullets && bullets.length > 0 && (
          <List
            sx={(theme) => ({
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'flex-start',
              columnGap: theme.spacing(1),
              rowGap: theme.spacing(1),
              mb: theme.spacing(2),
              pr: theme.spacing(6),
            })}
          >
            {bullets.map((value: string) => (
              <ListItem
                key={value}
                sx={(theme) => ({
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: theme.spacing(1.5),
                  width: 'auto',
                  p: 0,
                  mr: theme.spacing(4),
                  svg: {
                    color: theme.palette.brand.green,
                  },
                })}
              >
                <IconCircleCheckFilled />
                {value}
              </ListItem>
            ))}
          </List>
        )}
      </Container>
    </CustomBackground>
  );
}
